import GenerateLayerImagesModal from "./GenerateLayerImagesModal";

export default GenerateLayerImagesModal;
